import React from 'react';
import { OfficeEntity } from '../../models';

interface OfficeDetailContextType {
  office: OfficeEntity | null;
  officeId: number;
}

export const OfficeDetailContext = React.createContext<OfficeDetailContextType>({} as OfficeDetailContextType);
